const DecorLine = ({ color = "black" }) => {
  return (
    <div className="decor-line-container" style={{ color }}>
      <div className="decor-line-circle" />
      <div className="decor-line-middle" />
      <div className="decor-line-circle" />
    </div>
  );
};

export default DecorLine;
